/**
 *
 *  Module popin/popin
 *
 *  This module extends the jQuery dialog
 *  with children feature
 *
 */

'use strict';

const _ = require('lodash');
const uniqID = require('uniq-id');
const jQuery = require('jquery');
const container = require('./../../../core/container');
const mediator = require('./../../../core/mediator');
const PopinManager = require('./../');

require('jquery-ui/ui/widgets/dialog');

let defaultConfig = {
        'minHeight': 300,
        'autoOpen': false,
        'width': 460,
        'maxHeight': jQuery(window).height() - 40,
        'classes': {
          'ui-dialog': 'cloud-dialog',
        },
        'closeText': '',
        'open': function() {
            let config = {};
            let $current = jQuery(this);

            config.$popin = $current;
            mediator.publish('before:popin:open', config);

            if (container.get('isMobile')) {
                jQuery('html').addClass('cloud-no-scroll');
            }

            mediator.publish('on:popin:open', config);
        },
        'close': function() {
            if (container.get('isMobile')) {
                jQuery('html').addClass('cloud-no-scroll');
            }

            mediator.publish('on:popin:close');
        },
        'closeOnScroll': false,
    };

/**
 * Popin class
 *
 * @param {object} userSettings Config
 */
let Popin = function Popin(userSettings) {
    this.id = uniqID();
    this.rootElement = jQuery('<div/>');
    this.settings = _.clone(defaultConfig);
    this.settings.appendTo = userSettings.appendTo || container.get('$toolbar');
    this.children = [];
    this.init(userSettings);
};

/**
 * Initialize config and the dialog
 *
 * @param  {object} userSettings Config
 */
Popin.prototype.init = function(userSettings) {
    let self = this;

    userSettings = _.isObject(userSettings) ? userSettings : {};

    if (container.get('isMobile') && _.isString(userSettings.classes['ui-dialog'])) {
      userSettings.classes['ui-dialog'] = userSettings.classes['ui-dialog'] + ' cloud-dialog-mobile';
    }

    this.rootElement.attr('id', this.id);
    this.rootElement.append(jQuery('<div/>').addClass('popin-content'));
    this.settings = _.merge(this.settings, userSettings);

    jQuery(this.rootElement).dialog(this.settings);

    jQuery(this.rootElement).on('mousewheel DOMMouseScroll', function(e) {
        let height = jQuery(this).outerHeight();
        let d = Math.max(-1, Math.min(1, (e.originalEvent.wheelDelta || -e.originalEvent.detail)));

        if((this.scrollTop === (this.scrollHeight - height) && d < 0) || (this.scrollTop === 0 && d > 0)) {
            e.preventDefault();
        }
    });

    if (userSettings.closeOnScroll) {
        jQuery(document).on('scroll.popin', function() {
            jQuery(self.rootElement).dialog('close');
            jQuery(document).off('scroll.popin');
        });
        jQuery(window).scroll(function() {
            jQuery(this.rootElement).dialog('close');
        });
    }
};

/**
 * Get id of popin
 *
 * @returns {string} id
 */
Popin.prototype.getId = function() {
    return this.id;
};

/**
 * Shortcut of dialog option
 *
 * @param {string} key
 * @param {Mixed} value
 * @returns {object} popin
 */
Popin.prototype.setOption = function(key, value) {
    this.settings[key] = value;
    this.invoke('option', key, value);

    return this;
};

/**
 * Retrive the option or all options
 * if the key is not defined
 *
 * @param  {string} key [description]
 * @returns {Mixed}     [description]
 */
Popin.prototype.getOption = function(key) {
    let option = this.invoke('option');

    return _.isString(key) ? option[key] : option;
};

/**
 * Set the title of popin
 *
 * @param {string} title
 * @returns {object} Popin
 */
Popin.prototype.setTitle = function(title) {
    this.setOption('title', title);

    return this;
};

/**
 * Retrieve the title of popin
 *
 * @returns {string} title
 */
Popin.prototype.getTitle = function() {
    return this.getOption('title');
};

/**
 * Retrieve children of popin
 *
 * @returns {Array} children
 */
Popin.prototype.getChildren = function() {
    return this.children;
};

/**
 * Set content of popin
 *
 * @param {string} content
 * @returns {object} Popin
 */
Popin.prototype.setContent = function(content) {
    this.rootElement.find('.popin-content').html(content);

    return this;
};

/**
 * Retrieve content
 *
 * @returns {object} content
 */
Popin.prototype.getContent = function() {
    return this.rootElement.find('.popin-content');
};

/**
 * Shortcut of dialog event listener
 *
 * @param  {string}   eventName
 * @param  {Function} callback  [description]
 * @returns {object} Popin
 */
Popin.prototype.on = function(eventName, callback) {
    if (typeof eventName !== 'string') {
        throw new Error('Popin.on: `eventName` should be a string.');
    }

    if (typeof callback !== 'function') {
        throw new Error('Popin.on: `callback` should be a function.');
    }

    this.settings[eventName] = callback;

    this.rootElement.on('dialog' + eventName.toLowerCase(), callback);

    return this;
};

/**
 * Display the popin
 *
 * @returns {object} Popin
 */
Popin.prototype.display = function() {
    this.invoke('open');

    return this;
};

/**
 * Hide the popin
 *
 * @returns {object} Popin
 */
Popin.prototype.hide = function() {
    this.close();

    return this;
};

/**
 * Destroy the popin and each child
 * Then reset attributes
 *
 * @returns {object} Popin
 */
Popin.prototype.destroy = function() {
    this.invoke('destroy');

    PopinManager.removePopin(this);

    _.forEach(this.children, function(child) {
        child.destroy();
        PopinManager.removePopin(child);
    });

    this.rootElement = null;
    this.id = null;
    this.children = [];

    return this;
};

/**
 * Close the popin and each child
 *
 * @returns {object} Popin
 */
Popin.prototype.close = function() {
    this.invoke('close');

    _.forEach(this.children, function(value) {
        value.close();
    });

    return this;
};

/**
 * Create a child
 *
 * @param  {object} config
 * @returns {object} child
 */
Popin.prototype.createChild = function(config) {
    let child = new Popin(config);

    this.children.push(child);

    return child;
};

Popin.prototype.invoke = function(...args) {
    if (args.length === 0) {
        throw new Error('popin.invoke expects one parameter');
    }

    try {
        return this.rootElement.dialog(...args);
    } catch (e) {
        throw new Error('popin.invoke ' + e);
    }
};

module.exports = Popin;
